
import classes from './FretboardNotesSelect.module.css';

const FretboardNotesSelect = ({title, values, onUpdate }) => {
    
    const names = ["C", "C sharp or D flat", "D", "D sharp or E flat", "E", "F",
      "F sharp or G flat", "G", "G sharp or A flat", "A", "A sharp or B flat", "B"];
    const indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    const onUpdateHandler = (event) => {
         onUpdate(+event.target.id,event.target.checked);
      };
    
      const boxes = indexes.map((index) => {
        return (
          <td key={`${index}`}>
            <input
              aria-label={`${names[index]} notes`}
              className={classes.input}
              checked={values[index]}
              id={`${index}`}
              type="checkbox"
              onChange={onUpdateHandler}
            />
          </td>
        );
      });
    
      return (
        <tr>
          <td>{title}</td>
          {boxes}
        </tr>
      );
};

export default FretboardNotesSelect;